import { useQuery } from "@tanstack/react-query";
import api from "../../utils/api"

// 행사 정보 가져오기
const fetchSchedule = (reqData) => {
    const eventIdx = reqData.queryKey[1];
    return api({
        url: "/schedule/" + eventIdx
    }).then((data) => data.data);
}

// 등급 별 행사 조건 가져오기
const fetchScheduleGradeCondition = () => {

}

export const useScheduleQuery = (eventIdx) => {
    return useQuery({
        retry: 0,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        queryKey: ["schedule", eventIdx],
        queryFn: fetchSchedule,
        select: (data) => {
            return data.data;
        },
    });
};